var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"guest-page guest-page-body"},[_c('Toast',{attrs:{"position":"top-right"}}),_c('CapGuestHeader'),_c('main',{staticClass:"main"},[_c('div',{staticClass:"container"},[_c('router-view')],1)]),_c('router-view',{attrs:{"name":"submain"}}),_c('CapGuestFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }